module.exports = __webpack_public_path__ + "static/img/p_11.3ef8b7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_11.jpg
// module id = jv9C
// module chunks = 9